
// @ts-nocheck


export const localeCodes =  [
  "en",
  "hu"
]

export const localeLoaders = {
  en: [],
  hu: []
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/bfe45ecb" /* webpackChunkName: "config_i18n_46config_46ts_bfe45ecb" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      language: "en-US",
      _hreflang: "en-US",
      _sitemap: "en-US",
      files: []
    },
    {
      code: "hu",
      iso: "hu-HU",
      language: "hu-HU",
      _hreflang: "hu-HU",
      _sitemap: "hu-HU",
      files: []
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: false
  },
  differentDomains: false,
  baseUrl: "https://comind.telekom.hu",
  customRoutes: "config",
  pages: {
    "ai-mode": {
      en: "/ai-mode",
      hu: "/ai-mod"
    },
    cookie: {
      en: "/cookie-settings",
      hu: "/cookie-beallitasok"
    },
    "use-cases-slug": {
      en: "/use-cases/[slug]",
      hu: "/hasznalati-esetek/[slug]"
    },
    "documents-dslug": {
      en: "/documents/[dslug]",
      hu: "/dokumentumok/[dslug]"
    },
    "custom-package": {
      en: "/custom-package",
      hu: "/egyedi-csomag"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US",
    files: []
  },
  {
    code: "hu",
    iso: "hu-HU",
    language: "hu-HU",
    _hreflang: "hu-HU",
    _sitemap: "hu-HU",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/